import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, from as observableFrom, of as observableOf } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

import { State } from '®app/ngrx';
import { ReadingListDetails } from '®shared/reading-list/models';

import { ResumePublishListAction } from '../../state/container-edit.actions';
import {
  ContainerActionTypes,
  ContainerInitialisedAction,
} from '../../state/container.actions';

import { InitQueueAction, LockQueueForShiftAction } from './queue.actions';
import { selectQueueState } from './queue.state';

@Injectable()
export class QueueEffects {
  queueInit$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActionTypes.CONTAINER_INITIALISED),
      mergeMap((action: ContainerInitialisedAction) => {
        const list = action.payload.container as ReadingListDetails;
        const { id, list_etag, isPublishing, listPublishAction } = list;
        const initAction = new InitQueueAction({ etag: list_etag });

        if (isPublishing) {
          const resumePublishListAction = new ResumePublishListAction({
            listId: id,
            listEtag: list_etag,
            listPublishActionId: listPublishAction.id,
            status: listPublishAction.status,
          });

          return observableFrom([initAction, resumePublishListAction]);
        } else {
          return observableOf(initAction);
        }
      }),
    ),
  );

  queueChanges$: Observable<Action> = createEffect(() =>
    this.store.select(selectQueueState).pipe(
      filter(state => !state.queue.isEmpty() && !state.locked),
      mergeMap(state => {
        const apiAction = state.queue.get(0);
        const lockAction = new LockQueueForShiftAction();
        return observableFrom([lockAction, apiAction]);
      }),
    ),
  );

  constructor(private store: Store<State>, private actions$: Actions) {}
}
